import {
  SCORE_START_EVENT,
  SCORE_STOP_EVENT,
  SESSION_SCORE_KEY_PREFIX,
  SESSION_SCORE_TIMESTAMP_KEY_PREFIX,
} from './commentScoreConstants'

type Listener = (channelId: string) => void

let startListeners: Listener[] = []
let stopListeners: Listener[] = []

export const getScoreSessionKeys = (
  channelId: string,
): {
  scoreKey: string
  timestampKey: string
} => ({
  scoreKey: `${SESSION_SCORE_KEY_PREFIX}_${channelId}`,
  timestampKey: `${SESSION_SCORE_TIMESTAMP_KEY_PREFIX}_${channelId}`,
})

export const subscribeToScoreEvents = ({
  onStart,
  onStop,
}: {
  onStart?: Listener
  onStop?: Listener
}): (() => void) => {
  if (onStart) startListeners.push(onStart)
  if (onStop) stopListeners.push(onStop)

  const handleEvent = (e: Event): void => {
    const detail = (e as CustomEvent<string>).detail
    const channelId = typeof detail === 'string' ? detail : ''
    if (e.type === SCORE_START_EVENT && onStart) onStart(channelId)
    if (e.type === SCORE_STOP_EVENT && onStop) onStop(channelId)
  }

  window.addEventListener(SCORE_START_EVENT, handleEvent)
  window.addEventListener(SCORE_STOP_EVENT, handleEvent)

  return () => {
    startListeners = startListeners.filter((fn) => fn !== onStart)
    stopListeners = stopListeners.filter((fn) => fn !== onStop)
    window.removeEventListener(SCORE_START_EVENT, handleEvent)
    window.removeEventListener(SCORE_STOP_EVENT, handleEvent)
  }
}

export const triggerEngagementScoreStart = (channelId: string): void => {
  window.dispatchEvent(
    new CustomEvent(SCORE_START_EVENT, { detail: channelId }),
  )
}

export const triggerEngagementScoreStop = (channelId: string): void => {
  window.dispatchEvent(new CustomEvent(SCORE_STOP_EVENT, { detail: channelId }))
}
